import { PaymentProviderDto } from '@tiendanube/common';
import { PaymentProvidersCode } from '@tiendanube/common/src/domains/payments/providers/PaymentProvidersCode';
import { Country } from '@tiendanube/common/src/enums';
import { AUTO_SETTING_NUVEM_PAGO } from 'App/featuresFlags';
import { useHasTags } from 'App/hooks';
import { useGetCountry } from 'domains/Auth/hooks';
import { NUVEMPAGO_ACTIVE_STATUS_TAG_FOR_NEW_COHORTS_FEATURE_FLAG } from 'domains/NuvemPagoCommons/constants';
import { useNuvemPagoFeatureFlag } from 'domains/NuvemPagoCommons/hooks/useNuvemPagoFeatureFlag';

function useShouldShowPendingNuvemPagoBrasilAsActive(
  paymentProviders: PaymentProviderDto[],
) {
  const [hasTag] = useHasTags(AUTO_SETTING_NUVEM_PAGO);
  const country = useGetCountry();
  const isBrazil = country === Country.BR;

  const provider = paymentProviders.find(
    ({ id }) => id === PaymentProvidersCode.nuvemPago,
  );
  const hasNuvemPagoBr = !!provider;
  const isPending = hasNuvemPagoBr
    ? !!provider.mustCompleteInstallation || !!provider.processingInstallation
    : false;

  const skipFeatureFlagCheck =
    !isBrazil || !hasTag || !hasNuvemPagoBr || !isPending;
  const { isFeatureEnabled } = useNuvemPagoFeatureFlag(
    NUVEMPAGO_ACTIVE_STATUS_TAG_FOR_NEW_COHORTS_FEATURE_FLAG,
    { skip: skipFeatureFlagCheck || undefined },
  );

  const shouldShowPendingAsActive =
    isBrazil && hasTag && hasNuvemPagoBr && isPending && !!isFeatureEnabled;

  return {
    hasNuvemPagoBr,
    hasAutoInstallationTag: hasTag,
    isFeatureFlagEnabled: isFeatureEnabled,
    shouldShowPendingAsActive,
  };
}

export default useShouldShowPendingNuvemPagoBrasilAsActive;
